/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import {Field, reduxForm} from 'redux-form';
import RenderField from '../../../../../../common/components/Form/RenderField';
import _ from 'lodash';
import './index.css';
// import numeral from 'numeral';
import { calculatePrice } from '../../../../../../lib/calculatePrice';
import { grabSelectedRecipientKeys } from '../../../../../../lib/grabSelectedRecipientKeys';
import { generateHash } from '../../../../../../lib/generateHash';


class RecipientAddress extends React.Component {
  static propTypes = {
    handleSubmit: PropTypes.func,
    postCardForm: PropTypes.object,
    fetchAddress: PropTypes.func,
    subStep: PropTypes.object,
    addressFetchError: PropTypes.bool,
    lastFetchedAddressHash: PropTypes.number
  };

  componentDidMount () {
    const {
      postCardForm,
      fetchAddress,
      lastFetchedAddressHash,
      addressFetchError
    } = this.props;
    const addressStreet = _.get(postCardForm, 'values.streetAddress');
    const city = _.get(postCardForm, 'values.city');
    const state = _.get(postCardForm, 'values.state');
    const zip = _.get(postCardForm, 'values.zip');
    const address = {
      addressStreet,
      city,
      state,
      zip
    };

    const singleStringAddress = `${addressStreet} ${city} ${state} ${zip}`;
    const newAddressHash = generateHash(singleStringAddress);
    if(lastFetchedAddressHash !== newAddressHash) {
      fetchAddress(address);
    }
  }

  render() {
    const {
      handleSubmit,
      subStep,
      postCardForm,
      addressFetchError
    } = this.props;
    const addresses = _.get(subStep, 'addresses', []);
    const recipientsPreProcess = _.get(postCardForm, 'values.recipients', false);
    const selectedRecipients = grabSelectedRecipientKeys(recipientsPreProcess, addresses); // .keys(_.pickBy(postCardForm, 'values.recipients', _.identity));
    return (
      <form onSubmit={handleSubmit} className='hmr-recipient-address-container'>
        <div className='address-list'>
          {!addressFetchError && <h3>THE FIRST CARD, WHICH WILL BE SENT TO PRESIDENT & FIRST LADY TRUMP, IS FREE. We hope that you will also send your card to your other elected officials, making our collective ROAR way too loud for our leaders to ignore. We thank you for your contribution which will cover the costs of printing & mailing your postcards, plus ongoing advocacy addressing the opioid epidemic.</h3>}
          {addressFetchError &&
            <h3>Whoops! Your address is invalid. Please return to enter a valid address.</h3>
          }
          <div className='hmr-address-row'>
            <div className='checkbox-container'>
              <Field
                type="price-checkbox"
                name={`recipients.0`}
                component={RenderField}
                price='free'
              />
            </div>
            <div className='address'>
              <p className='address-line first-line'>Send my postcard to President & First Lady Trump only</p>
            </div>
          </div>
          {addresses && addresses.map((address, key) => (
            <div className='hmr-address-row' key={key}>
              {key === 0 &&
                <React.Fragment>
                  <div className='checkbox-container'>
                    <Field
                      type="price-checkbox"
                      name={`recipients.1`}
                      component={RenderField}
                      price={10.00}
                    />
                  </div>
                  <div className='address'>
                    <p className='address-line first-line hmr-bold'>Send a full set of cards (including 1 free card to President & First Lady Trump) to:</p>
                  </div>
                </React.Fragment>
              }
              {key > 0 &&
                <div className='address'>
                  <p className='address-line'>{address.officialInfo.fullName}</p>
                  <p className='address-line'>{address.officialInfo.address[0].line1}</p>
                  {_.get(address, 'officialInfo.address[0].line2') &&
                  <p className='address-line'>{address.officialInfo.address[0].line2}</p>
                  }
                  <p className='address-line'>{`${address.officialInfo.address[0].city}, ${address.officialInfo.address[0].state} ${address.officialInfo.address[0].zip}`}</p>
                </div>
              }
            </div>
          ))}
        </div>
        {!addressFetchError &&
        <div className='postcard-summary'>
          <div className='amount'><span># Cards: </span>{`${selectedRecipients.length}`}</div>
          <div className='total-price'><span>Total Price:</span> {`${calculatePrice(selectedRecipients, 'dollar-value')}`}</div>
          <div className='clear'></div>
        </div>}
      </form>
    );
  }
}

export default reduxForm({
  form: 'postcard',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  enableReinitialize: true
})(RecipientAddress);



// WEBPACK FOOTER //
// ./src/routes/CreateRoar/StepThree/components/PostcardAddressEntryStep/RecipientAddress/index.js